import React from "react";
import { useParams } from "react-router-dom";
import {
  FaShoppingCart,
  FaTimes,
  FaPlus,
  FaArrowLeft,
  FaLock,
} from "react-icons/fa";
import SidebarCartItem from "./SidebarCartItem";
import PopularItemCard from "./PopularItemCard";
import { currencySymbolLeft } from "../../../../functions/Functions";

const CartSidebar = ({
  isCartOpen,
  setIsCartOpen,
  cartItems,
  handleAddToCart,
  handleRemoveFromCart,
  setInstructionModalState,
  cartSubTotal,
  cartTax,
  cartTotal,
  orderDetail,
  loading,
  handlePlaceOrder,
  popularItems,
  handleItemClick,
  isOrderPunchingEnabled,
  table_name,
  showImages = true,
  getPaymentTaxRate
}) => {
  const { id, tableName, orderType } = useParams();

  return (
    <div
      className={`cart-sidebar bg-white shadow-lg ${isCartOpen ? "open" : ""}`}
    >
      <div className="cart-header p-3 d-flex align-items-center justify-content-between cart-header-dark">
        <div className="d-flex align-items-center">
          <button
            className="btn text-white p-0 mr-3 d-flex align-items-center justify-content-center cart-back-btn"
            onClick={() => setIsCartOpen(false)}
          >
            <FaArrowLeft size={18} />
          </button>
          <div className="d-flex flex-column text-white">
            <span className="cart-header-title-text">Your Order</span>
            <span className="cart-header-subtitle">
              {Object.values(cartItems).reduce(
                (sum, item) => sum + item.quantity,
                0,
              )}{" "}
              item
              {Object.values(cartItems).reduce(
                (sum, item) => sum + item.quantity,
                0,
              ) !== 1
                ? "s"
                : ""}
            </span>
          </div>
        </div>

        {table_name && (
          <div className="d-flex align-items-center px-3 py-1 cart-table-badge">
            <FaLock className="mr-2" size={10} /> {table_name.toUpperCase()}
          </div>
        )}
      </div>

      <div className="cart-body p-3 flex-grow-1 overflow-auto cart-body-bg">
        {Object.values(cartItems).length === 0 ? (
          <div className="text-center text-muted mt-5">
            <FaShoppingCart size={48} className="mb-3 opacity-25" />
            <p className="font-weight-md empty-cart-text">
              Your cart is empty.
            </p>
          </div>
        ) : (
          <div className="cart-items-list">
            {Object.values(cartItems).map((item) => (
              <SidebarCartItem
                key={item.id}
                item={item}
                onAddToCart={handleAddToCart}
                onRemoveFromCart={handleRemoveFromCart}
                onEditInstruction={(cartItem) =>
                  setInstructionModalState({ isOpen: true, item: cartItem })
                }
                showImage={showImages}
              />
            ))}

            <div className="add-more-items text-center">
              <button
                className="btn btn-sm w-100 py-2 fw-bold add-more-items-btn add-more-items-dashed d-flex justify-content-center align-items-center"
                onClick={() => setIsCartOpen(false)}
              >
                <FaPlus className="mr-2" size={12} /> Add more items
              </button>
            </div>

            <div className="cart-summary-card bg-white p-3 shadow-sm my-3">
              <div className="cart-summary-title mb-3">Order Summary</div>

              <div className="d-flex justify-content-between mb-2">
                <span className="cart-summary-text">Subtotal</span>
                <span className="cart-summary-text">
                  {currencySymbolLeft()} {cartSubTotal}
                </span>
              </div>

              {cartTax ? (
                <div className="d-flex justify-content-between">
                  <span className="cart-summary-text">
                    Tax ({getPaymentTaxRate ? getPaymentTaxRate() : (orderDetail?.branch?.branch_tax ?? 0)}%)
                  </span>
                  <span className="cart-summary-text">
                    {currencySymbolLeft()} {cartTax}
                  </span>
                </div>
              ) : null}
              <hr />
              <div className="d-flex justify-content-between mb-3 font-weight-md">
                <span className="cart-total-text">Total</span>
                <span className="cart-total-text">
                  {currencySymbolLeft()} {cartTotal}
                </span>
              </div>
            </div>
            <hr />

            {popularItems && popularItems.length > 0 && (
              <div className="mt-3 pt-3 border-top popular-items-wrapper">
                <div className="d-flex align-items-center mb-3 px-1">
                  <span className="sidebar-item-price">🔥</span>
                  <div className="font-weight-md text-dark sidebar-item-name">
                    Popular with your order
                  </div>
                </div>
                <div className="d-flex overflow-auto pb-2 popular-scroll-container gap-2">
                  {popularItems.slice(0, 5).map((item) => (
                    <PopularItemCard
                      key={item.id}
                      item={item}
                      onClick={handleItemClick}
                      isSidebar={true} showImage={showImages}
                      isOrderPunchingEnabled={isOrderPunchingEnabled}
                      cartItem={cartItems[item.id || item.name]}
                      onRemoveFromCart={handleRemoveFromCart}
                    />
                  ))}
                </div>
              </div>
            )}
          </div>
        )}
      </div>

      {Object.values(cartItems).length > 0 && (
        <div className="cart-footer p-3 bg-white border-top shadow-lg cart-footer-container">
          <button
            disabled={loading}
            className="btn text-white w-100 rounded-pill d-flex justify-content-between align-items-center shadow place-order-btn px-4"
            onClick={handlePlaceOrder}
          >
            <span>{(orderType && orderDetail.branch?.qsr_card_payment) ?  "Proceed To Checkout" : "Place Order"}</span>
            <span>
              {currencySymbolLeft()} {cartTotal}
            </span>
          </button>
        </div>
      )}
    </div>
  );
};

export default React.memo(CartSidebar);
